import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3fa7614"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sp-product-ads"
};
const _hoisted_2 = {
  class: "sp-product-ads-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pa-header-and-count"
}, [/*#__PURE__*/_createTextVNode(" Products "), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " Resume/Pause individual campaign strategies ")], -1));
const _hoisted_4 = {
  class: "asin-sku-enabled-paused-count"
};
const _hoisted_5 = {
  key: 0,
  class: "enabled-paused-count"
};
const _hoisted_6 = {
  class: "search-bar"
};
const _hoisted_7 = {
  class: "sp-pa-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_play_icon = _resolveComponent("play-icon");
  const _component_pause_icon = _resolveComponent("pause-icon");
  const _component_app_input = _resolveComponent("app-input");
  const _component_ppc_s_p_product_ad_item = _resolveComponent("ppc-s-p-product-ad-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_app_icon, {
    icon: "cross",
    size: 20,
    color: "#616161",
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = () => this.$emit('close'))
  })]), _createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString($options.filteredItems?.length) + " " + _toDisplayString($props.group_by_type?.toUpperCase()) + _toDisplayString($options.filteredItems?.length > 1 ? 's' : '') + " ", 1), $options.pausedCount || $options.enabledCount ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$options.enabledCount ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['enabled-count', {
      no_paused: !$options.pausedCount
    }])
  }, [_createVNode(_component_play_icon), _createTextVNode(" " + _toDisplayString($options.enabledCount), 1)], 2)) : _createCommentVNode("", true), $options.pausedCount ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['paused-count', {
      no_enabled: !$options.enabledCount
    }])
  }, [_createVNode(_component_pause_icon), _createTextVNode(" " + _toDisplayString($options.pausedCount), 1)], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_app_input, {
    modelValue: $options.localSearch,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.localSearch = $event),
    v2: "",
    version: "ba-search",
    placeholder: `Search products (${$options.filteredItems?.length})`,
    class: "search-input"
  }, null, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredItems, (item, index) => {
    return _openBlock(), _createBlock(_component_ppc_s_p_product_ad_item, {
      item: index === 0 ? {
        ...item,
        nextItemSame: item.asin === $options.filteredItems[index + 1]?.asin
      } : item.asin !== $options.filteredItems[index - 1]?.asin ? {
        ...item,
        nextItemSame: item.asin === $options.filteredItems[index + 1]?.asin
      } : {
        ...item,
        asin: '',
        asin_name: '',
        asin_image: 'dot',
        nextItemSame: item.asin === $options.filteredItems[index + 1]?.asin
      },
      selected_profile_id: $props.selected_profile_id,
      country_code: $props.country_code
    }, null, 8, ["item", "selected_profile_id", "country_code"]);
  }), 256))])]);
}